import browser from '@lib/utils/browser.js'
import { mpUtils } from '@tujia/fe-lib-bridge'

export default {
  methods: {
    /** 用于判断环境 */
    getEnv() {
      return new Promise((resolve, reject) => {
        const ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('tujia') >= 0 || ua.indexOf('mayi') >= 0) {
          return resolve(2)
        } else if (ua.indexOf('micromessenger') >= 0 && window.wx && window.wx.miniProgram && window.wx.miniProgram.getEnv) {
          // eslint-disable-next-line
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              return resolve(1)
            } else {
              return resolve(3)
            }
          })
        } else if (browser.versions.isZFBMiniProgram) {
          return resolve(7)
        } else {
          return resolve(4)
        }
      })
    },
    async mayiLogin({ autoGetRedpacketId } = {}) {
      const platform = await this.getEnv()
      window.localStorage.setItem('isFromLoginPage', 1)
      const _clientHref = `${window.location.href}${autoGetRedpacketId ? '&autoGetRedpacketId=' + autoGetRedpacketId : ''}`
      if (platform === 2) {
        // 跳转客户端登录页
        if (window.tjBridge) {
          const appInit = require('@/utils/mayiAppInit').default
          window.tjBridge.business.login({
            action: 2,
            success: (res) => {
              let { userId, userToken } = res
              appInit({
                tjuserid: userId,
                tjusertoken: userToken
              })
              window.location.replace(_clientHref)
            },
            fail: (res) => {
            // errorcode=10012,取消
              console.log(res)
            },
            final: () => {}
          })
        } else {
          window.location.href = `${process.env.VUE_APP_MAYI_HOST_HD}/wap/login?returnurl=${_clientHref}&srcLocalSite=goSite`
        }
      } else if (platform === 1 && this.tjChannelId === 'tujia') {
        const query = this.$route.query
        const code = query.code || query.tujia_code
        // eslint-disable-next-line
        const id = query.id
        // 跳转小程序登录页
        let url = `/pages/wechatShare/tjlogin/index?gourl=${encodeURIComponent(_clientHref)}&code=${code}&type=public`
        mpUtils.redirectTo({
          url
        })
      } else {
        // 移动端浏览器跳转登录页
        if (this.$root.isMobile) {
          window.location.href = `${process.env.VUE_APP_MAYI_HOST_HD}/wap/login?returnurl=${_clientHref}`
        } else {
          window.location.href = `${process.env.VUE_APP_MAYI_HOST_HD}/wap/login?returnurl=${_clientHref}`
        }
      }
    }
  }
}
